import { processCorrelations } from "@/_core/data/api_calls/correlations/processCorrelations";
import { gatewayService } from "@/_services/gateway.service";

export function getCommodityCorrelations(ctx, assetExtraParams) {
  const variables = {
    format: "json",
    commodity: assetExtraParams.commodityNumber,
    contract: assetExtraParams.contract
  };
  return processCorrelations(ctx, {
    fetch: gatewayService.market.correlations,
    variables
  });
}
